import { X } from "lucide-react";
import React, { useRef, useState } from "react";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

export default function AppointmentCancellationModal({
  account_id,
  location_id,
  handleAppointmentCancellation = () => {},
  onClose = () => {},
  selectedAppointment = null,
  cancelModal =false,
  smsLimit = 0,
}) {
  const [cancelReason, setCancelReason] = useState("");
  const [sendSMS, setSendSMS] = useState(false);
  const dropdownRef = useRef(null);

  const handleCancelAppointment = () => {
    const postData = {
      account_id: account_id,
      location_id: location_id,
      status: "cancelled",
      comment: cancelReason,
      appointment_time: selectedAppointment.appointment_time,
      dont_send_sms: sendSMS,
      hex_id: selectedAppointment.hex_id,
    };
    handleAppointmentCancellation(postData);
    onClose();
  };
  
  const handleSendSMSCheck = (e) => {
    const isChecked = e.target.checked;
    if(isChecked){
      setSendSMS(true);
    } else {
      setSendSMS(false)
    }
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={cancelModal} onOpenChange={onClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small">
            <Drawer.Title className="sr-only">OTP Confirmation</Drawer.Title>
            <Drawer.Description className="sr-only">OTP confirmation modal for send email</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                <div className="docpro_deleteboxbox modal_height_100">
                  <div className="docpro_text_left">
                    <button
                      className="docpro_close_btn"
                      onClick={onClose}
                    >
                      <X />
                    </button>
                    <h2 className="docpro_fs_24 docpro_mb_0">Appointment Cancellation</h2>
                    <Spacing lg="20" sm="20" />
                    <label className="docpro_fw_500 docpro_primary_color">
                      Cancel Reason
                    </label>
                    <textarea
                      className="docpro_form_field size_lg"
                      cols="30"
                      rows="5"
                      onChange={(e) => setCancelReason(e.target.value)}
                    ></textarea>
                    <Spacing lg="20" sm="20" />
                    <p className="docpro_fw_500 mb-1 docpro_accent_color">Your Available Message Credit: {smsLimit.available_credit}</p>
                    <div className="docpro_checkbox docpro_tip_checkbox" >
                      <input
                        type="checkbox"
                        value={true}
                        name="id" 
                        onChange={handleSendSMSCheck}
                      />
                      <label style={{ marginLeft: "8px" }}> Avoid sending a text message to the patient. </label>
                      <span className="docpro_tip" style={{ textAlign: 'center' }}>If checked, the patient has not received <br />any confirmation SMS</span>
                    </div>
                    <Spacing lg="20" sm="20" />
                  </div>
                  <button
                    className="docpro_bordered_btn docpro_fw_500 docpro_filed_btn docpro_btn_red docpro_mt_auto"
                    style={{ width: "100%", padding: "10px 12px" }}
                    onClick={() => {handleCancelAppointment()}}
                  >
                    <span>Yes, Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
